(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('Access', Access);

    Access.$inject = ['$resource', 'DateUtils'];

    function Access ($resource, DateUtils) {
        var resourceUrl =  'api/accesses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.placementDate = DateUtils.convertLocalDateFromServer(data.placementDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.placementDate = DateUtils.convertLocalDateToServer(copy.placementDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.placementDate = DateUtils.convertLocalDateToServer(copy.placementDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();
